/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Session_NameInputs */

const th_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หัวข้อที่ฝึก`)
};

const en_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What it covers`)
};

const ja_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容`)
};

const zh_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课程内容`)
};

const es_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De qué trata`)
};

const pt_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do que se trata`)
};

const id_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang apa`)
};

const fr_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce qu’elle couvre`)
};

const tl_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tungkol saan`)
};

const vi_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội dung`)
};

const ko_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주제`)
};

const de_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worum es geht`)
};

const ru_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О чём занятие`)
};

const tr_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konusu`)
};

const it_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Argomento`)
};

const pl_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czego dotyczą`)
};

const uk_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Про що заняття`)
};

const hi_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`किस बारे में`)
};

const ar_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`موضوعها`)
};

const ms_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengenai apa`)
};

const bn_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কী নিয়ে`)
};

const zh_tw2_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`課程內容`)
};

const zh_hk2_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`課節內容`)
};

const ur_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کس بارے میں`)
};

const fa_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دربارهٔ چه`)
};

const sw_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuhusu nini`)
};

const nl_event_session_name = /** @type {(inputs: Event_Session_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarover`)
};

/**
* | output |
* | --- |
* | "What it covers" |
*
* @param {Event_Session_NameInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_session_name = /** @type {((inputs?: Event_Session_NameInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Session_NameInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_session_name(inputs)
	if (locale === "ja") return ja_event_session_name(inputs)
	if (locale === "zh") return zh_event_session_name(inputs)
	if (locale === "es") return es_event_session_name(inputs)
	if (locale === "pt") return pt_event_session_name(inputs)
	if (locale === "id") return id_event_session_name(inputs)
	if (locale === "fr") return fr_event_session_name(inputs)
	if (locale === "tl") return tl_event_session_name(inputs)
	if (locale === "vi") return vi_event_session_name(inputs)
	if (locale === "ko") return ko_event_session_name(inputs)
	if (locale === "de") return de_event_session_name(inputs)
	if (locale === "ru") return ru_event_session_name(inputs)
	if (locale === "tr") return tr_event_session_name(inputs)
	if (locale === "it") return it_event_session_name(inputs)
	if (locale === "pl") return pl_event_session_name(inputs)
	if (locale === "uk") return uk_event_session_name(inputs)
	if (locale === "hi") return hi_event_session_name(inputs)
	if (locale === "ar") return ar_event_session_name(inputs)
	if (locale === "ms") return ms_event_session_name(inputs)
	if (locale === "bn") return bn_event_session_name(inputs)
	if (locale === "zh-TW") return zh_tw2_event_session_name(inputs)
	if (locale === "zh-HK") return zh_hk2_event_session_name(inputs)
	if (locale === "ur") return ur_event_session_name(inputs)
	if (locale === "fa") return fa_event_session_name(inputs)
	if (locale === "sw") return sw_event_session_name(inputs)
	if (locale === "nl") return nl_event_session_name(inputs)
	return en_event_session_name(inputs)
});